import Relation from './relation'

export default class RelationBuilder
  constructor: (@name, @model, @route) ->

  for: (repository) ->
    new Relation(repository.baseUrl, @route, repository.auth, @model, repository.associations)
